import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  BranchTableCellViewModel,
  BranchTableViewModel,
} from '../../models/autogenerated-piping';

@Component({
    selector: 'app-branch-table-display',
    templateUrl: './branch-table-display.component.html',
    styleUrls: ['./branch-table-display.component.scss'],
    standalone: false
})
export class BranchTableDisplayComponent implements OnInit {
  @Input() branchTableVM: BranchTableViewModel;
  @Input() pipeClassId: string;
  branchSizes: number[] = [];
  headerSizes: number[] = [];
  cellArrayRaw: BranchTableCellViewModel[][] = [];
  cellArray: BranchTableCellViewModel[][] = [];
  colCount = 1;
  rowCount = 1;
  higlightBranchIndex: number = null;
  highlightHeaderIndex: number = null;

  constructor(
    private readonly cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    if (this.branchTableVM?.branchTablePipeClassViewModels) {
      this.createCellArray();
    } else {
      this.createCellArray();
    }
  }

  private createCellArray() {
    if (!this.branchTableVM?.cells || this.branchTableVM.cells.length === 0) {
      console.warn('⚠️ Branch table has no cells to display:', this.branchTableVM?.name);
      return;
    }

    try {
      this.getBranchSizes();
      this.getHeaderSizes();
      this.populateCellArrayRows();

      // Force change detection after creating cell array to ensure proper rendering
      setTimeout(() => {
        if (this.cdr) {
          this.cdr.detectChanges();
        }
      }, 0);
    } catch (error) {
      console.error('❌ Error creating cell array for branch table:', this.branchTableVM?.name, error);
    }
  }

  private getBranchSizes() {
    if (!this.branchTableVM?.cells) {
      this.branchSizes = [];
      this.rowCount = 0;
      return;
    }

    const uniqueBranchSizesSet = new Set(
      this.branchTableVM.cells.map((cell) => cell.branchSize).filter(size => size !== null && size !== undefined)
    );
    this.branchSizes = [...uniqueBranchSizesSet].sort((a, b) => a - b);
    this.rowCount = this.branchSizes.length;
  }

  private getHeaderSizes() {
    if (!this.branchTableVM?.cells) {
      this.headerSizes = [];
      this.colCount = 0;
      return;
    }

    const uniqueHeaderSizesSet = new Set(
      this.branchTableVM.cells.map((cell) => cell.headerSize).filter(size => size !== null && size !== undefined)
    );
    this.headerSizes = [...uniqueHeaderSizesSet].sort((a, b) => b - a);
    this.colCount = this.headerSizes.length;
  }

  private populateCellArrayRows() {
    for (const branchSize of this.branchSizes) {
      const cellRowArray = [];
      for (const cell of this.branchTableVM.cells) {
        if (cell.branchSize === branchSize) {
          cellRowArray.push(cell);
        }
      }
      cellRowArray.sort((a, b) => b.headerSize - a.headerSize);
      this.cellArrayRaw.push(cellRowArray);
    }
    this.sortCellArrayRaw();
    this.populateCellArray();
  }

  private populateCellArray() {
    for (const row of this.cellArrayRaw) {
      this.populateCellRow(row);
    }
  }

  private populateCellRow(row: BranchTableCellViewModel[]) {
    const cellRow: BranchTableCellViewModel[] = [];
    for (const size of this.headerSizes) {
      let found = false;
      for (const cell of row) {
        if (cell.headerSize == size && !found) {
          found = true;
          cellRow.push(cell);
        }
      }
    }
    this.cellArray.push(cellRow);
  }

  private sortCellArrayRaw() {
    this.cellArrayRaw.sort((a, b) => {
      if (a[0].branchSize > b[0].branchSize) {
        return -1;
      }
      if (a[0].branchSize < b[0].branchSize) {
        return 1;
      }
      return 0;
    });
  }

  getDataCellClass(cell: BranchTableCellViewModel): string {
    if (cell.branchTableCode.length === 0) {
      return "empty-cell";
    } else {
      return 'data-cell';
    }
  }

  getBranchSizeCellClass(cell: number): string {
    if (cell === this.higlightBranchIndex) {
      return 'header-branch-size-cell-highlight';
    } else {
      return 'header-branch-size-cell';
    }
  }

  getHeaderSizeCellClass(cell: number): string {
    if (cell == this.highlightHeaderIndex) {
      return 'header-branch-size-cell-highlight';
    } else {
      return 'header-branch-size-cell';
    }
  }

  public getBranchCodeFromCell(cell: BranchTableCellViewModel): string {
    return cell.branchTableCode.map(c => c.code).join('/');

  }

  onCellMouseOver(event: MouseEvent, cell: BranchTableCellViewModel) {
    const targetElement = event.target as HTMLElement;
    if (cell.branchTableCode.length !== 0) {
      targetElement.classList.add('data-cell-hover');
    }

    this.highlightHeaderIndex = cell.headerSize;
    this.higlightBranchIndex = cell.branchSize;
  }

  onCellMouseLeave(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    targetElement.classList.remove('data-cell-hover');
    this.highlightHeaderIndex = null;
    this.higlightBranchIndex = null;
  }
}
